module.exports = __webpack_public_path__ + "static/media/TeamsSelected.2c3c1ab5.svg";